export const CART = "cart";
// export const BASE_PATH = "http://localhost:1337";
export const STRIPE_KEY =
  "pk_test_51J9ah3B5mV1hVUa18Aa6zLbRlUjVTwbejw1UQ2y9WzJxgRuxAfpD5n50JTi4Bm1LYSFs4ftORPNrDsl7zQmBdtXm00aC85gYt5";
// export const STRIPE_KEY =
//   "pk_live_51J9ah3B5mV1hVUa1nd4fsGSzB9faVc9d4qjVNief4vTNAyitjXENflKcfaN4OxBbG1DpT3e2u2iaLTBGAGW1QrZc00U9CmakZQ";
